<template>
    <v-snackbar v-model="shows" bottom light>
        <span class="font-size-14 font-size-md-16"> {{ cash.amount?.format?.() }}원이 적립되었습니다. </span>

        <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="shows = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    props: {
        cash: { type: Object, default: () => {} },
    },
    data: () => ({
        shows: true,
    }),
};
</script>

<style></style>
